import type { CalendarUpsertSchema } from '@repo/schemas/meeting/calendarUpsert';
import type { UseFormReturn } from 'react-hook-form';

import { useGetLocations } from '@repo/api/location/useGetLocations';

import { MeetingTypeFormField } from '@/components/features/meeting/MeetingTypeFormField';

interface TypeRadioGroupFieldProps {
  form: UseFormReturn<CalendarUpsertSchema>;
}

export function TypeRadioGroupField(meetingFormTypeRadioGroupProps: TypeRadioGroupFieldProps) {
  const { form } = meetingFormTypeRadioGroupProps;
  const { data: locations = [], isPending } = useGetLocations();

  return (
    <MeetingTypeFormField<CalendarUpsertSchema, 'type', 'meetingURL', 'location'>
      form={form}
      typeName={'type'}
      meetingURLName={'meetingURL'}
      locationName={'location'}
      locations={locations}
      isLocationsPending={isPending}
    />
  );
}
